module.exports = __webpack_public_path__ + "static/media/Colette Wing Single Headboard - 120 cm_Beige.213c4506.png";